module.exports = __webpack_public_path__ + "1575c05cdbe87c6555578fbc1ece274a.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/hausplanner/img/top_logo.png
// module id = 1762
// module chunks = 1